import { render, staticRenderFns } from "./PayBoxTefActions.vue?vue&type=template&id=2b529b19&scoped=true&"
import script from "./PayBoxTefActions.vue?vue&type=script&lang=js&"
export * from "./PayBoxTefActions.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxTefActions.vue?vue&type=style&index=0&id=2b529b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b529b19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b529b19')) {
      api.createRecord('2b529b19', component.options)
    } else {
      api.reload('2b529b19', component.options)
    }
    module.hot.accept("./PayBoxTefActions.vue?vue&type=template&id=2b529b19&scoped=true&", function () {
      api.rerender('2b529b19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/PayBoxTefActions.vue"
export default component.exports